import "slick-carousel";
import { resizeBackgroundImages } from "../responsive-images";

const $slides = $(".slider-products .slider__slides");

$slides.each(function() {
  const $this = $(this);
  const sliderImages = document
    .querySelector(".slider-products")
    .querySelectorAll(".responsive-background-image");

  $this.slick({
    arrows: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerMode: false,
    variableWidth: false,
    adaptiveHeight: false,
    autoplaySpeed: 10000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $this.on("afterChange", function(slick, currentSlide) {
    setTimeout(function() {
      resizeBackgroundImages(sliderImages);
    }, 1000);
  });
});
